
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NavItemFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NavItem"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"target"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"path"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isDiscoverNav"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isRental"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":105}};
    doc.loc.source = {"body":"fragment NavItemFields on NavItem {\n  name\n  target\n  type\n  path\n  logoUrl\n  isDiscoverNav\n  isRental\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
